/**
 * Medical Dictation integration config.
 *
 * NOTE: This is a frontend build-time secret in the current architecture.
 * Prefer providing `REACT_APP_REPORT_ENGINE_SECRET` via the build environment.
 */

export const MEDICAL_DICTATION_DICTIONARY_PHRASES_SECRET =
  process.env.REACT_APP_REPORT_ENGINE_SECRET ||
  process.env.REPORT_ENGINE_SECRET ||
  "9367ee968658a0c9b338e15de2adfc96dc9849fede654d2e39ec64b817f36f48";

export const MEDICAL_DICTATION_DICTIONARY_PHRASES_SECRET_HEADER =
  "X-Report-Engine-Secret";

